import { render, staticRenderFns } from "./ModalPacientesAdicionales.vue?vue&type=template&id=8b4f82ca"
import script from "./ModalPacientesAdicionales.vue?vue&type=script&lang=js"
export * from "./ModalPacientesAdicionales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports